import { render, staticRenderFns } from "./vipServeUser.vue?vue&type=template&id=612a5b0a&scoped=true"
import script from "./vipServeUser.vue?vue&type=script&lang=js"
export * from "./vipServeUser.vue?vue&type=script&lang=js"
import style0 from "./vipServeUser.vue?vue&type=style&index=0&id=612a5b0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612a5b0a",
  null
  
)

export default component.exports